import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import _ from 'lodash';

@Directive({
   selector: '[samwebOutsideClick]',
})
export class OutsideClickDirective {
   constructor(public elementRef: ElementRef) {
      _.delay(() => (this.allowClose = true), 100);
   }

   @Output()
   public samwebOutsideClick = new EventEmitter();

   // fix to handle shadow dom problem!
   // see https://stackoverflow.com/questions/47977020/does-node-contains-work-when-working-with-shadow-dom-in-angular-2
   private allowClose = false;

   @HostListener('document:click', ['$event'])
   public documentClick(event: any): void {
      if (!this.contains(event.target) && this.allowClose) {
         this.samwebOutsideClick.emit();
      }
      this.allowClose = true;
   }

   @HostListener('click', ['$event'])
   clickInside(event: any) {
      this.allowClose = false;
   }

   private contains(target: any): boolean {
      return this.elementRef.nativeElement.contains(target);
   }
}
